import { useRef, useEffect } from "react"
import * as echarts from "echarts"

interface EChartViewProps {
  option: echarts.EChartsOption | null
  height?: number | string
}

export function EChartView({ option, height = 400 }: EChartViewProps) {
  const chartRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (!chartRef.current) return
    const chart = echarts.init(chartRef.current, undefined, { renderer: "canvas" })
    chart.setOption(option || {}, true)
    const onResize = () => chart.resize()
    window.addEventListener("resize", onResize)
    const ro = new ResizeObserver(onResize)
    ro.observe(chartRef.current)
    return () => {
      window.removeEventListener("resize", onResize)
      ro.disconnect()
      chart.dispose()
    }
  }, [option])
  const styleHeight = typeof height === "string" ? height : height
  return <div ref={chartRef} style={{ width: "100%", height: styleHeight }} />
}
